export default {
  Eo: "allowCrawlerActivity",
  _o: "baseUrl",
  Io: "noCookies",
  So: "devicePropertyAllowlist",
  Aa: "disablePushTokenMaintenance",
  Ao: "enableLogging",
  No: "enableSdkAuthentication",
  qa: "manageServiceWorkerExternally",
  Oo: "minimumIntervalBetweenTriggerActionsInSeconds",
  Ro: "sessionTimeoutInSeconds",
  Po: "appVersion",
  Lo: "appVersionNumber",
  Ma: "serviceWorkerLocation",
  ka: "safariWebsitePushId",
  zn: "localization",
  bo: "contentSecurityNonce",
  Do: "allowUserSuppliedJavascript",
  jo: "inAppMessageZIndex",
  ho: "openInAppMessagesInNewTab",
  en: "openNewsFeedCardsInNewTab",
  Lh: "requireExplicitInAppMessageDismissal",
  Mo: "doNotLoadFontAwesome",
  Uo: "deviceId",
  _a: "serviceWorkerScope",
  Wo: "sdkFlavor",
  tn: "openCardsInNewTab",
};
